<template>
  <v-card v-if="select" class="pa-5">
    <v-form
      v-if="!inscriptionSentFlag"
      ref="form"
      v-model="valid"
      lazy-validation
    >
      <v-container>
        <v-row align="center" justify="center">
          <v-col cols="10" md="11">
            <v-select
              :disabled="disabledSelect"
              v-model="select"
              :items="symposiums"
              item-text="name"
              filled
              :rules="[(v) => !!v || 'Item is required']"
              :label="$t('inscription.simposio')"
              required
              return-object
            ></v-select>
          </v-col>
          <v-col cols="2" md="1">
            <v-btn @click="swipeLanguage()" icon x-large
              ><v-icon>mdi-translate</v-icon>
            </v-btn>
          </v-col>
        </v-row>
        <!--
        <template>
          <span class="primary--text">{{ $t("registrationCloseDate") }}</span>
        <b class="primary--text">{{ $t("registrationCloseDate2") }}</b>
        </template>
        -->
        <template v-if="select.openInscriptions && !$store.state.loading">
          <b class="primary--text">{{
            this.getLanguage === "es"
              ? select.headerTextSpanish
              : select.headerTextEnglish
          }}</b>
        </template>
        <template v-if="!select.openInscriptions && !$store.state.loading">
          <span class="primary--text">{{ $t("registrationCloseDate") }}</span>
          <b class="primary--text">{{ $t("registrationCloseDate2") }}</b>
        </template>
        <v-divider></v-divider>
        <template v-if="select.openInscriptions">
          <v-row>
            <v-col cols="12" md="12" lg="12">
              <v-text-field
                v-model="name"
                :counter="20"
                :rules="nameRules"
                :label="$t('inscription.name')"
                required
              ></v-text-field
            ></v-col>
            <v-col cols="12" md="12" lg="12">
              <v-text-field
                v-model="surname"
                :counter="40"
                :rules="nameRules"
                :label="$t('inscription.surname')"
                required
              ></v-text-field>
            </v-col>

            <v-col cols="12" md="12" lg="12">
              <v-text-field
                v-model="institution"
                :counter="20"
                :rules="nameRules"
                :label="$t('inscription.university')"
                required
              ></v-text-field
            ></v-col>
            <v-col cols="12" md="12" lg="12">
              <v-text-field
                v-model="rol"
                :counter="20"
                :rules="nameRules"
                :label="$t('inscription.rol')"
                required
              ></v-text-field
            ></v-col>
            <v-col cols="12" md="12" lg="12">
              <v-menu
                ref="menu"
                v-model="menu"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="dateOfBirth"
                    :label="$t('inscription.dateOfBirth')"
                    prepend-icon="mdi-calendar"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                  :max="
                    new Date(
                      Date.now() -
                        595960900000 -
                        new Date().getTimezoneOffset() * 60000
                    )
                      .toISOString()
                      .substr(0, 10)
                  "
                  v-model="dateOfBirth"
                  @input="menu = false"
                  no-title
                  scrollable
                >
                </v-date-picker>
              </v-menu>
            </v-col>
            <v-col class="mb-0 pb-0" cols="12" md="12" lg="12">
              <v-select
                v-if="countryCodes"
                v-model="nacionality"
                :items="countryCodes"
                item-text="name"
                filled
                :rules="[(v) => !!v || 'Item is required']"
                :label="$t('inscription.nacionality')"
                required
                return-object
              ></v-select>
            </v-col>
            <v-col cols="12" md="12" lg="12">
              <v-text-field
                v-model="idNumber"
                :counter="40"
                :rules="nameRules"
                :label="$t('inscription.idNumber')"
                required
              ></v-text-field
            ></v-col>
            <v-col cols="12" md="12" lg="12">
              <v-text-field
                v-model="address"
                :counter="20"
                :rules="nameRules"
                :label="$t('inscription.address')"
                required
              ></v-text-field
            ></v-col>

            <v-col cols="12" md="12" lg="12">
              <v-text-field
                v-model="city"
                :counter="20"
                :rules="nameRules"
                :label="$t('inscription.city')"
                required
              ></v-text-field
            ></v-col>
            <v-col cols="12" md="12" lg="12">
              <v-text-field
                v-model="zipCode"
                :rules="numberRule"
                :label="$t('inscription.cp')"
                required
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="12" lg="12">
              <v-text-field
                v-model="country"
                :counter="20"
                :rules="nameRules"
                :label="$t('inscription.country')"
                required
              ></v-text-field
            ></v-col>
          </v-row>
          <v-row class="mb-0">
            <v-col class="mb-0 pb-0" cols="5" md="3" lg="3">
              <v-select
                v-if="countryCodes"
                v-model="selectCountryCode"
                :items="countryCodes"
                :hint="`${selectCountryCode.name}, ${selectCountryCode.code}`"
                item-text="name"
                filled
                :rules="[(v) => !!v || 'Item is required']"
                :label="$t('inscription.prefix')"
                required
                return-object
              ></v-select>
            </v-col>
            <v-col class="mb-0 pb-0" cols="7" md="9" lg="9">
              <v-text-field
                v-model="phone"
                :rules="phoneRule"
                :label="$t('inscription.phone')"
                required
              >
              </v-text-field>
            </v-col>
          </v-row>
          <v-col cols="12" md="12" lg="12">
            <v-text-field
              v-model="email"
              :rules="emailRules"
              label="Email"
              required
            ></v-text-field>
          </v-col>
          <v-col cols="12" md="12" lg="12">
            <v-text-field
              v-model="altEmail"
              :rules="[altEmailRules.equal(email)]"
              :label="$t('inscription.altEmail')"
              required
            ></v-text-field
          ></v-col>
          <v-col cols="12" md="12" lg="12">
            <v-text-field
              v-model="emergencyContactInfo"
              :counter="100"
              :rules="longTextRules"
              :label="$t('inscription.emergencyContactInfo')"
              required
            >
            </v-text-field>
          </v-col>
          <v-row class="pa-0 ma-0">
            <v-col class="pa-0 ma-0" cols="12" md="8" lg="8">
              <v-checkbox
                v-model="previousAssistance"
                :label="$t('inscription.previousAssistance')"
                required
              ></v-checkbox>
            </v-col>
            <v-col class="pa-0 ma-0" cols="12" md="4" lg="4">
              <v-text-field
                v-if="previousAssistance"
                v-model="previousAssistanceYear"
                :label="$t('inscription.assistanceYear')"
                required
              ></v-text-field>
            </v-col>
            <v-col
              v-if="$route.params.acronym != 'UNIES'"
              class="pa-0 ma-0"
              cols="12"
              md="8"
              lg="8"
            >
              <v-checkbox
                v-model="previousScholarship"
                :label="$t('inscription.previousScholarship')"
                required
              ></v-checkbox>
            </v-col>
            <v-col
              v-if="$route.params.acronym != 'UNIES'"
              class="pa-0 ma-0"
              cols="12"
              md="4"
              lg="4"
            >
              <v-text-field
                v-if="previousScholarship"
                v-model="previousScholarshipYear"
                :label="$t('inscription.previousScholarshipYear')"
                required
              ></v-text-field>
            </v-col>
          </v-row>
          <br />

          <v-file-input
            class="mt-5"
            :rules="fileRules"
            v-model="curriculum"
            accept=".pdf"
            :label="$t('inscription.curriculum')"
          ></v-file-input>
          <v-file-input
            :rules="fileRules"
            v-model="letter"
            accept=".pdf"
            :label="$t('inscription.letter')"
          ></v-file-input>

          <v-btn
            :disabled="!valid"
            :color="select.color ? select.color : 'green'"
            class="ma-4 white--text"
            @click="createInscription"
          >
            {{ $t("inscription.sendInscription") }}
          </v-btn>
          <v-btn color="grey" class="ma-4 white--text" @click="reset">
            {{ $t("inscription.eraseFields") }}
          </v-btn>
        </template>
      </v-container>
    </v-form>
    <v-container v-else class="pa-7 grey lighten-2" fluid>
      <v-row class="ma-5" align="center" justify="center">
        <span class="body-1">{{ $t("inscription.inscriptionSent") }}</span>
      </v-row>
    </v-container>
  </v-card>
</template>

<script>
import { getSymposiums } from "@/services/symposiums.js";
import { createInscription } from "@/services/inscriptions.js";
import countryCodes from "@/utils/countryCodes.json";
import { mapMutations, mapGetters } from "vuex";

export default {
  async mounted() {
    this.$store.commit("setLoadingFlag", true);
    await this.timeout(3000);

    this.symposiums = await getSymposiums();
    this.select = this.symposiums.find(
      (elem) => elem.acronym == this.$route.params.acronym
    );
    if (this.select) {
      this.disabledSelect = true;
    }
    this.countryCodes = countryCodes;
    this.$store.commit("setLoadingFlag", false);
  },
  data: () => ({
    symposiums: [],
    disabledSelect: false,
    selectCountryCode: "",
    inscriptionSentFlag: false,
    valid: true,
    countryCodes: [],
    curriculum: null,
    letter: null,
    address: "",
    name: "",
    surname: "",
    idNumber: "",
    rol: "",
    institution: "",
    city: "",
    country: "",
    zipCode: "",
    email: "",
    altEmail: "",
    phone: "",
    previousAssistanceYear: 0,
    previousScholarshipYear: 0,
    previousScholarship: false,
    emergencyContactInfo: "",
    nacionality: "",
    dateOfBirth: "",
    menu: false,
    nameRules: [
      (v) => !!v || "Name is required",
      (v) => (v && v.length <= 20) || "Name must be less than 20 characters",
    ],
    longTextRules: [
      (v) => !!v || "Field is required",
      (v) => (v && v.length <= 100) || "Field must be less than 100 characters",
    ],
    fileRules: [
      (v) => !!v || "File is required",
      (v) =>
        (v && v.name.match(/\.[0-9a-z]+$/i)[0] == ".pdf") ||
        "File must be .pdf",
    ],
    emailRules: [
      (v) => !!v || "E-mail is required",
      (v) => /.+@.+\..+/.test(v) || "E-mail must be valid",
    ],
    altEmailRules: {
      equal(email) {
        return (v) =>
          (v != email && /.+@.+\..+/.test(v) && !!v) ||
          "Alt Email must be valid and different from email";
      },
    },
    numberRule: [
      (v) =>
        (!isNaN(parseFloat(v)) && v >= 0 && v <= 99999) ||
        "Number has to be between 0 and 99999",
    ],
    yearRule: [
      (v) =>
        (!isNaN(parseFloat(v)) && v >= 1990 && v <= new Date().getFullYear()) ||
        "Year has to be between 1990 and current year",
    ],
    phoneRule: [
      (v) =>
        (!isNaN(parseFloat(v)) && v >= 0 && v <= 99999999999999) ||
        "Number has to be between 0 and 99999999999999",
    ],
    select: {},
    previousAssistance: false,
  }),
  computed: {
    ...mapGetters(["getLanguage"]),
  },

  methods: {
    ...mapMutations(["changeLanguage"]),

    validate() {
      this.$refs.form.validate();
    },
    reset() {
      this.$refs.form.reset();
    },
    resetValidation() {
      this.$refs.form.resetValidation();
    },

    swipeLanguage() {
      this.$vuetify.lang.current = this.getLanguage === "es" ? "en" : "es";
      this.changeLanguage(this.getLanguage === "es" ? "en" : "es");
    },
    timeout(ms) {
      return new Promise((resolve) => setTimeout(resolve, ms));
    },
    async createInscription() {
      if (this.$refs.form.validate()) {
        console.log("validación correcta");
        this.$store.commit("setLoadingFlag", true);
        var data = {
          acronym: this.select.acronym,
          sympId: this.select.id,
          address: this.address,
          name: this.name,
          surname: this.surname,
          idNumber: this.idNumber,
          rol: this.rol,
          institution: this.institution,
          city: this.city,
          country: this.country,
          zipCode: this.zipCode,
          email: this.email,
          altEmail: this.altEmail,
          phone: this.selectCountryCode.code + " " + this.phone,
          previousAssistance: this.previousAssistance,
          reviewed: false,
          previousScholarship: this.previousScholarship,
          previousAssistanceYear: this.previousAssistanceYear,
          previousScholarshipYear: this.previousScholarshipYear,
          emergencyContactInfo: this.emergencyContactInfo,
          dateOfBirth: this.dateOfBirth,
          nacionality: this.nacionality.name,
          //here new fields only for management
          inscriptionDate: new Date(),
          askedScholarshipThisYear: false,
          fullName: "",
          coordinatorNote: "",
          givenScholarshipThisYear: false,
          letterMailed: false,
          confirmationLetterMailed: "",
          paymentDate: "",
          typeOfLetterEmailed: "",
          confirmationAfterLetterEmail: false,
          amountOwed: 0,
          finalAmountPaid: 0,
          noteAboutPayment: "",
          hotelInfo: "",
          flightInfo: "",
          coordinatorsNote: "",
        };
        await createInscription(
          data,
          this.curriculum,
          this.letter
        );
       // console.log("inscripción enviada", createInscriptionResponse);
       this.$store.commit("setLoadingFlag", false);
      this.inscriptionSentFlag = true;
      } else {
        console.log("validación incorrecta");
      }
    },
  },
};
</script>
<style lang="scss" scoped></style>
